module.exports = __webpack_public_path__ + "media/img/specialize/specialize-in-bg-b343e221baebde71f139be9623a01944.svg";